import { render } from "./pb-textdual.vue?vue&type=template&id=451c293c"
import script from "./pb-textdual.vue?vue&type=script&lang=js"
export * from "./pb-textdual.vue?vue&type=script&lang=js"

import "./pb-textdual.vue?vue&type=style&index=0&id=451c293c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__